module.exports = __webpack_public_path__ + "media/usp-trackers-d322008e.svg";